import { defaultReturn, generateDefaultActions, makeWritePayload } from "shared-utility/store/utils/helpers";

// ACTIONS

export const SET_CALCULATED_FIELD_SELECTIONS = generateDefaultActions("SET_CALCULATED_FIELD_SELECTIONS");
export const setCalculatedFieldSelections = payload => makeWritePayload(SET_CALCULATED_FIELD_SELECTIONS.value, payload);

export const SET_CALCULATED_FIELDS_TO_DEFAULT = generateDefaultActions("SET_CALCULATED_FIELDS_TO_DEFAULT");
export const setCalculatedFieldsToDefault = payload => makeWritePayload(SET_CALCULATED_FIELDS_TO_DEFAULT.value, payload);

export const actionCreators = {
  setCalculatedFieldSelections,
  setCalculatedFieldsToDefault
};

// REDUCER
const initialState = {
  calculatedFieldFieldsFilter: "0",
  calculatedFieldSearchTerm: "",
  selectedCalculation: null,
  previewValue: null
};

export function lenderReportCalculatedFieldReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_CALCULATED_FIELD_SELECTIONS.value:
      return defaultReturn({ ...state, ...payload });

    case SET_CALCULATED_FIELDS_TO_DEFAULT.value:
      return defaultReturn({ ...initialState });

    default:
      return state;
  }
}
